import { render } from "./UserFeedbackForm.vue?vue&type=template&id=65cfc834&scoped=true"
import script from "./UserFeedbackForm.vue?vue&type=script&lang=js"
export * from "./UserFeedbackForm.vue?vue&type=script&lang=js"

import "./UserFeedbackForm.vue?vue&type=style&index=0&id=65cfc834&scoped=true&lang=css"

import exportComponent from "/home/nodeapps/vitamins/edna/frontendBuild/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65cfc834"]])

export default __exports__